<template>
    <vs-row style="margin: 2.5px;" vs-justify="center" vs-w="12">
        <vs-col class="dynamic-input">
            <vs-input
                v-if="type === 'input' || type === 'text-telephone' || type === 'text-email'"
                v-model="localValue"
                :label="label"
                width="100%"
                v-mask="type === 'text-telephone' ? '(##) #########' : false"
                :type="type === 'text-email' ? 'email' : 'text'"
                :name="name"
                :danger="danger || characterCount >= 60"
                danger-text="Campo obrigatório. Limite de caracteres: 60."
                v-on:input="$emit('input', localValue)"
            >
            <template v-slot:append>
                <div v-if="characterCount > 0">{{ characterCount }}/60</div>
              </template>
        </vs-input>
            <vs-select
                v-else-if="type === 'select'"
                v-bind:class="classes"
                :label="label"
                v-model="localValue"
                :name="name"
                :danger="danger"
                danger-text="Campo obrigatório."
                v-on:input="$emit('input', localValue)"
                placeholder="Selecione"
                noData="Nenhum dado encontrado"
                width="100%"
                autocomplete
            >
                <vs-select-item
                    v-if="!required"
                    value=""
                    text="Selecione"
                />
                <vs-select-item
                    v-for="(option, i) in items"
                    :key="i"
                    :value="option.value"
                    :text="option.title || option.value"
                />
            </vs-select>
            <vs-textarea
                v-else-if="type === 'textarea'"
                :label="label"
                v-model="localValue"
                :name="name"
                width="100%"
                v-on:input="$emit('input', localValue)"
            />
        </vs-col>
    </vs-row>
</template>

<script>
export default {
    name: "DynamicInput",
    props: [
        "type",
        "name",
        "label",
        "items",
        "required",
        "danger",
        "classes",
        "value",
    ],
    data: () => ({
        localValue: "",
    }),
    created() {
        this.localValue = this.value
    },
    computed: {
  characterCount() {
    return this.localValue.length;
  }
},
    watch: {
        value(newValue) {
            this.localValue = newValue
        },
        items() {
            this.$emit('input', "")
        }
    }
}
</script>

<style>
.dynamic-input .vs-con-input-label,
.dynamic-input .con-select,
.dynamic-input .vs-con-textarea {
  text-align: left;
}
</style>
